
export class Coupon {
    couponCode: string;
    couponDescription: string;
    offerType: string;
    offer: number;
    couponType: string;
    field: string;
    fieldCondition: string;
    fieldValue: number;
    couponId: string;
    amountType: string;
    typeValue: number;
    minimumTotal: number;
    conditionType: string;
    category: [{
        superCategoryId: string,
        mainCategoryId: string,
        subCategoryId: string
       }]
}
